import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ThumbDownAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"thumb_down_alt"}/>
}
